exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".labSelect {\n  display: inline-flex;\n  width: 185px;\n}\n.labSelect .xs-searchSelect-paper {\n  align-self: flex-end;\n}\n", ""]);

// exports
